import { render, staticRenderFns } from "./CourseWrite.vue?vue&type=template&id=73dbef66&"
import script from "./CourseWrite.vue?vue&type=script&lang=js&"
export * from "./CourseWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports